import { render, staticRenderFns } from "./classTitle.vue?vue&type=template&id=0e72892e&scoped=true&"
import script from "./classTitle.vue?vue&type=script&lang=js&"
export * from "./classTitle.vue?vue&type=script&lang=js&"
import style0 from "./classTitle.vue?vue&type=style&index=0&id=0e72892e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e72892e",
  null
  
)

export default component.exports